import { gql } from '@/__generated__';

const UPDATE_USER = gql(`#graphql
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        name
        lastnames
        email
        phone
        phoneNumber
        callingCode
        picture
        twoFactorAuth
        shouldAuth
        status
        access {
          controlCenter
          allDevices
          stations
          users
          virtualStations
          integrations
          dataAnalytics
          dataAdvanceAnalytics
          gates
          systems
          distribution
          dgaReports
          dataExtraction
          deviceConfiguration
          dataTables
          offLogin
          permits
          apiCapta
          distributionMaipo
          metricView
          deviceDiagnostics
          sendCommand
          channelNetwork
          audit
          standardDesign
          announcements
          notifications
          organizations
          billing
          alerts
          smaReports
          alertNotification
          viewAllocation
        }
        mainOrganization {
          organization {
            id
            name
          }
          role {
            id
            name
          }
        }
        additionalOrganizations {
          organization {
            id
            name
          }
          role {
            id
            name
          }
        }
      }
    }
  }
`);

export default UPDATE_USER;
